export const ERROR_TYPE = {
    invalid_isInput: "필수입력값이 비어있습니다.",
    already_replied: "이미 회신에 응답하였습니다.",
    already_end_date_survey: "기한이 만료된 회신입니다.",
    start_date_violation_survey: "답변 시작일시 이전으로 답변을 동록할 수 없습니다.",
    already_last_closed: "선착순 인원이 꽉 찼습니다.",
    invalid_answer: "답변을 작성해주세요.",
    no_matched_type: "회신질문 타입에 맞지 않는 응답값이 들어있음",
    invalid_sub_answer: "하위질문에 대한 답변을 작성해주세요.",
    no_matched_message: "일치하는 메시지가 없습니다.",
    no_matched_survey: "일치하는 회신이 없습니다.",
    invalid_message_id: "회신 정보가 일치하지 않습니다. -1",
    invalid_survey_result_id: "회신 정보가 일치하지 않습니다. -2",
    answer_out_of_range: "최대 입력 가능한 응답 개수를 초과했습니다.",
    answer_out_of_first_come: "선택하신 보기는 선착순 마감되었습니다.",
    too_much_request: "인증번호 재빌송은 30초에 한 번만 가능합니다.",
    no_matched_code: "인증번호가 일치하지 않습니다.",
    invalid_user: "인증 정보를 찾을 수 없습니다.",
    invalid_reservation_id: "예약 정보를 찾을 수 없습니다.",
    status_not_changed: "해당 예약건은 이미 처리완료 되었습니다."
};
